/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/no-empty-object-type */

import { z } from "zod";
import { fromError } from "zod-validation-error";

const envSchema = z.object({
  STRAPI_INTERNAL_URL: z.string().min(1),
  VITE_STRAPI_PUBLIC_URL: z.string().min(1),
}) satisfies z.ZodObject<Record<string, z.ZodString>>;

function validateEnv() {
  console.log("validating env variables");
  try {
    const envs = envSchema.parse({
      ...import.meta.env,
      ...process.env,
    });
    console.log("envs", envs);
  } catch (err) {
    console.error(fromError(err).toString());

    throw new Error("Invalid environment variables");
  }
}

type Env = z.infer<typeof envSchema>;
type PublicPrefix = "VITE_";
type PublicKey = keyof Env & `${PublicPrefix}${string}`;
type PublicEnv = Pick<Env, PublicKey>;
type PrivateEnv = Omit<Env, PublicKey>;

const getEnv = <T extends keyof Env>(env: T): Env[T] => {
  // @ts-ignore
  return (import.meta.env[env] ?? process.env[env]) as Env[T];
};

type ViteBuiltInEnv = {
  MODE: "development" | "production" | "test";
  DEV: boolean;
  SSR: boolean;
  PROD: boolean;
  BASE_URL: string;
};

declare global {
  interface ImportMetaEnv extends PublicEnv, ViteBuiltInEnv {}

  interface ImportMeta {
    readonly env: ImportMetaEnv;
  }

  namespace NodeJS {
    interface ProcessEnv extends PrivateEnv {}
  }
}

export { validateEnv, getEnv };
